import { ref } from 'vue';
import { scrollToTop } from '../../../helpers/scrollToTop';

export const useOnSubmit = () => {
    const isSubmitting = ref(false);
    const status = ref(null);
    const registeredEmail = ref(null);
    const responseMessage = ref('');

    const scrollToTopSucces = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    };

    const onSubmit = (data) => {
        if (isSubmitting.value) {
            isSubmitting.value = false;
            return;
        }

        isSubmitting.value = true;

        const formData = new FormData();

        formData.append('personalInformation', JSON.stringify(data.personalInformation));
        formData.append('registrationEmail', data.registerEmail);
        formData.append('password', data.password);
        formData.append('action', 'register_customer');

        fetch(jsData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((response) => {
                isSubmitting.value = false;
                return response.json();
            })
            .then((response) => {
                if (response.success) {
                    registeredEmail.value = data.registerEmail;
                    status.value = 'success';
                    scrollToTopSucces();

                    if (document.querySelector('.form-container')) {
                        document.querySelector('.form-container').style.minHeight =
                            'auto!important';
                    }
                } else {
                    status.value = 'error';
                    responseMessage.value = response.data.message;
                    scrollToTop();
                }
            });
    };

    return { onSubmit, isSubmitting, status, registeredEmail, responseMessage };
};
